// extracted by mini-css-extract-plugin
export default {"placeholderText":"list_placeholderText__aJMCy"};